import type { ReactNode } from 'react';

export interface SeitenkopfProps {
  titel: string;
  beschreibung?: string;
  aktion?: ReactNode;
}

export function Seitenkopf({ titel, beschreibung, aktion }: SeitenkopfProps) {
  return (
    <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="text-xl font-semibold text-fg">{titel}</h1>
        {beschreibung && (
          <p className="mt-1 max-w-2xl text-sm leading-relaxed text-fg-muted">{beschreibung}</p>
        )}
      </div>
      {aktion && <div className="shrink-0">{aktion}</div>}
    </div>
  );
}
